export const ActivityFlags = {
    renewPassportLinkClicked: 'renewPassportLinkClicked',
    shangrilaLinkClicked: 'shangrilaLinkClicked',
    visaLinkClicked: 'visaLinkClicked',    
};